import { render } from "./HiAvatarGroup.vue?vue&type=template&id=3b5b8ca8"
import script from "./HiAvatarGroup.vue?vue&type=script&lang=js"
export * from "./HiAvatarGroup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__